<template>
  <div class="contentbox">
    <div class="conten">
      <ul class="equipment_management" :class="show_search_state?'show_search':''">
        <li class="header_search" :class="show_search_state?'show_search':''">
          <div class="search_input_box">
            <div>
              <el-select @change="onsearch"
                         v-model="search_data.library_status"
                         size="mini" placeholder="請選擇">
                <el-option
                  label="all"
                  value="">
                </el-option>
                <el-option
                  label="已完成"
                  value="2">
                </el-option>
                <el-option
                  label="未完成"
                  value="1">
                </el-option>
              </el-select>
            </div>
            <div>
              <el-date-picker
                v-model="search_data.startTime"
                type="date"
                @change="onsearch"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="保修到期日/購買日期">
              </el-date-picker>
              ~
              <el-date-picker
                v-model="search_data.endTime"
                type="date"
                @change="onsearch"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="保修到期日/購買日期">
              </el-date-picker>
            </div>
            <div>
              <el-input @change="onsearch"
                        v-model="search_data.keyword"
                        size="mini" placeholder="關鍵字"></el-input>
            </div>
            <div>
              <el-button size="mini" type="success" @click="onsearch">查找</el-button>
            </div>
            <!--<div>-->
            <!--<el-button size="mini" type="success" @click="onsearch">查詢</el-button>-->
            <!--</div>-->
          </div>
          <i class="el-icon-arrow-down" @click="showsearchbox"></i>
        </li>
        <!--生產訂單-->
        <!--出庫單表頭-->
        <li
          class="header_list"
          v-if="$route.query.page_style !== 'management'"
          :class="show_search_state?'show_search':''">
          <div>
            生產單號
          </div>
          <div>
            {{$store.state.Order_list_fields.czry.name}}
          </div>
          <!--客人名稱-->
          <div>
            {{$store.state.Order_list_fields.kr.name}}
          </div>
          <!--添加時間-->
          <div>
            <!--{{$store.state.Order_list_fields.tjsj.name}}-->
            訂單日期
          </div>
          <!--要求時間-->
          <div>
            <!--{{$store.state.Order_list_fields.yqsj.name}}-->
            要求日期
          </div>
          <div>
            產品名稱
          </div>
          <div>
            產品編號
          </div>
          <!--自定義狀態-->
          <div>
            {{$store.state.Order_list_fields.zdzt.name}}
          </div>
          <!--lab 快遞單號-->
          <div>
            {{$store.state.Order_list_fields.labkddh.name}}
          </div>
          <div>金額</div>
          <!--備註-->
          <div>
            {{$store.state.Order_list_fields.bz.name}}
          </div>
          <!--導出-->
          <div>
            {{$store.state.Order_list_fields.dc.name}}
          </div>
        </li>
        <!--出庫單列表-->
        <li v-if="$route.query.page_style !== 'management'"
            v-for="(itme,index) in delivery_list"
            :key="index" @click.self="new_equipment(itme)">
          <!--<div>{{itme.assets_name}}</div>-->
          <div @click.self="new_equipment(itme)">{{itme.library_code}}</div>
          <div @click.self="new_equipment(itme)">{{itme.company_name}}</div>
          <div @click.self="new_equipment(itme)">{{itme.contact_name}}</div>
          <div @click.self="new_equipment(itme)">{{itme.create_time_s}}</div>
          <div @click.self="new_equipment(itme)">{{itme.ship_date}}</div>
          <div @click.self="new_equipment(itme)">{{itme.product_name}}</div>
          <div @click.self="new_equipment(itme)">{{itme.product_code}}</div>
          <div @click.self="new_equipment(itme)">{{itme.library_status === '2' ? '已完成' : '未完成'}}</div>
          <div @click.self="new_equipment(itme)">{{itme.odd_numbers}}</div>
          <div @click.self="new_equipment(itme)">{{itme.order_amount}}</div>
          <div @click.self="new_equipment(itme)">{{itme.remarks}}</div>
          <div v-if="$store.state.Order_list_fields.dc.status === '1' && $store.state.Order_list_fields.dc.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.dc.order"
               class="child_but_box">
            <el-dropdown trigger="click" @command="select_pdf">
                    <span class="el-dropdown-link">
                       <mt-button size="small" type="primary">Export</mt-button>
                    </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(list,index) in pdf_list"
                                  :key="index"
                                  :command="[itme.library_id,list.templates_id]">
                  {{list.templates_title}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </li>

        <!--賬單管理-->
        <!--出庫單表頭-->
        <li
          class="header_list"
          v-if="$route.query.page_style === 'management'"
          :class="show_search_state?'show_search':''">
          <div>生產單號</div>
          <div>客戶名稱</div>
          <div>客戶編號</div>
          <div>患者姓名</div>
          <div>賬單類型</div>
          <div>賬單號碼</div>
          <div>賬單日期</div>
          <div>金額</div>
          <div>快遞號碼</div>
          <div>出庫日期</div>
          <!--<div>備註</div>-->
          <!--導出-->
          <div>{{$store.state.Order_list_fields.dc.name}}</div>
        </li>
        <!--出庫單列表-->
        <li v-if="$route.query.page_style === 'management'"
            v-for="(itme,index) in delivery_list"
            :key="index" @click.self="new_equipment(itme)">
          <!--<div>{{itme.assets_name}}</div>-->
          <div @click.self="new_equipment(itme)">{{itme.library_code}}</div>
          <div @click.self="new_equipment(itme)">{{itme.company_name}}</div>
          <div @click.self="new_equipment(itme)">{{itme.company_full_number}}</div>
          <div @click.self="new_equipment(itme)">{{itme.contact_name}}</div>
          <div @click.self="new_equipment(itme)">{{itme.remarks}}</div>
          <div @click.self="new_equipment(itme)">{{itme.delivery_code}}</div>
          <div @click.self="new_equipment(itme)">{{itme.create_time_s}}</div>
          <div @click.self="new_equipment(itme)">{{itme.order_amount}}</div>
          <div @click.self="new_equipment(itme)">{{itme.odd_numbers}}</div>
          <div @click.self="new_equipment(itme)">{{itme.shipping_date_s}}</div>
          <!--<div @click.self="new_equipment(itme)">{{itme.remarks}}</div>-->
          <div v-if="$store.state.Order_list_fields.dc.status === '1' && $store.state.Order_list_fields.dc.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.dc.order"
               class="child_but_box">
            <el-dropdown trigger="click" @command="select_pdf">
                    <span class="el-dropdown-link">
                       <mt-button size="small" type="primary">Export</mt-button>
                    </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(list,index) in pdf_list"
                                  :key="index"
                                  :command="[itme.library_id,list.templates_id]">
                  {{list.templates_title}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </li>

      </ul>
      <div class="add_order_but" @click="new_equipment(false)">
        <i class="el-icon-circle-plus-outline"></i>
      </div>
      <div class="bottom_but">
        <!--<div v-if="$store.state.list_class === 0">-->
        <!--<el-button type="success" @click="printit">-->
        <!--PRINT-->
        <!--</el-button>-->
        <!--<el-button type="success" @click="on_export_execl">-->
        <!--導出EXCEL-->
        <!--</el-button>-->
        <!--<el-button type="success" @click="add_import_excel_box = true">-->
        <!--導入EXCEL-->
        <!--</el-button>-->
        <!--</div>-->
        <div></div>

        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          background
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
        <!--<el-button v-show="list_class === 0" @click="switch_list(2)" type="success">技工所</el-button>-->
        <!--<el-button v-show="list_class === 2" @click="switch_list(1)" type="success">原列表</el-button>-->
        <!--<el-button v-show="list_class === 1" @click="switch_list(0)" type="success">員工</el-button>-->
      </div>

    </div>
    <div v-show="showmode" @click="onhiddenmode" class="pdfimgmode">
      <iframe :src="pdfimgurl"></iframe>
    </div>
  </div>
</template>

<script>
  import {MessageBox, Button, Toast} from 'mint-ui';
  import {
    showlist,
    import_excel,
    export_execl_dow_url,
    downloadTemplate,
    get_assets,
    get_fixedassets_search_data,
    getSelectionTemplates,
    exportPdf_library,
  } from '../../assets/js/api'

  export default {
    name: "orderlist",
    data() {
      return {
        show_search_state: false, //顯示搜索
        delivery_list: [], //出庫列表
        currentPage: 1,//當前頁數
        search_data: {
          library_status: '', //完成状态，1 未完成，2 完成
          startTime: '', //搜索的開始時間
          endTime: '', //搜索的結束時間
          keyword: '', //搜索的關鍵字
          page: 1, //頁數
        },
        total: 0,//數據總數
        pdf_list: [],//pdf模板列表
        pdfimgurl: '',//pdf模板列表
        showmode: false,//pdf模板列表
      }
    },
    components: {
      MessageBox,
      Button,
      Toast,
    },
    mounted() {
      // 获取模板列表
      getSelectionTemplates('warehouse_temp_id').then(data => {
        if (data.status) {
          this.pdf_list = data.data.tempData
        }
      })

      this.currentPage = Number(this.$route.query.currentPage) || 1

      this.this_date = this.get_this_date()

      this.onsearch()
    },
    methods: {
      select_pdf(command) {
        this.ongetpdf(command[0], command[1],command[2])
      },
      onhiddenmode() {
        this.showmode = false
        this.pdfimgurl = ''
      },
      ongetpdf(id, pdfid,templates_type) {
        let p_data = {
          templates_id: pdfid,
          id: id,
        }
        exportPdf_library(p_data).then(data=>{
          this.showmode = true
          this.pdfimgurl = data.filePath
          if (!navigator.userAgent.match(/(phone|UC|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
            // window.open(this.pdfimgurl, '_blank')
          }
          else {
            // window.open(this.pdfimgurl, '_self')
          }
        }).catch((e) => {
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: '請求出錯',
            })
          }
          else {
            this.$alert('請求出錯', '提示', {
              confirmButtonText: '确定',
            });
          }
        })
      },
      // 搜索
      onsearch(field){
        if (field === 'field') {
          this.search_data.keyword = ''
          get_fixedassets_search_data(this.search_data.title_name).then(data => {
            if (data.status) {
              this.field_list = data.data
            }
          })
        }
        showlist(this.search_data).then(data => {
          if (data.status) {
            this.delivery_list = data.data
            this.total = Number(data.library_page_total_num)
          }
        })
      },
      // 获取当天日期
      get_this_date(){
        let myDate = new Date();
        let F = myDate.getFullYear()
        let M = myDate.getMonth() + 1
        let D = myDate.getDate()
        if (M < 10) {
          M = '0' + M
        }
        if (D < 10) {
          D = '0' + D
        }
        return F + '-' + M + '-' + D
      },
      showsearchbox() {
        if (this.show_search_state) {
          this.show_search_state = false
        }
        else {
          this.show_search_state = true
        }
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.search_data.page = val
        this.onsearch()
        // console.log(`当前页: ${val}`);
      },
      new_equipment(item_data){
        // 新增出庫單
        if (item_data){
          sessionStorage.setItem('delivery_details', JSON.stringify(item_data))
        }
        sessionStorage.removeItem('LocalShoppingCart')
        this.$router.push({path: '/delivery_details/?page_style=local'});
      }
    },
    destroyed() {//离开该页面需要移除这个监听的事件
      window.removeEventListener('scroll', this.handleScroll)
    }
    ,
  }
</script>

<style lang="less" scoped>
  @import "../../assets/less/base";

  html, body, #app {
    height: 100%;
  }

  .contentbox {
    /*background-color: #f2f2f2;*/
    width: 100%;
    .conten {
      margin-top: 52px;
      ul.equipment_management {
        background: #fff;
        padding-bottom: 1px;
        /*min-height: 96vh;*/
        margin-top: 52px;
        padding-top: 104px;
        transition: all 0.5s;
        &.show_search {
          padding-top: 140px;
        }
        li {
          background-color: #f2f2f2;
          width: 96%;
          padding: 20px 2%;
          margin: 5px 0;
          display: flex;
          /*flex-direction: column;*/
          align-items: center;
          justify-content: space-around;
          > div {
            width: 12%;
            min-width: 5%;
            text-align: center;
            cursor: pointer;
            word-wrap: break-word;
            .modify_tag {
              border-bottom: 1px #000 dotted;
              display: inline-block;
              padding: 5px;
              min-width: 50%;
            }
          }
          &.white {
            background: white;
          }
          &.header_list {
            position: fixed;
            background-color: #57c5f7;
            padding: 20px 2%;
            margin: 0;
            z-index: 9;
            top: 80px;
            border-bottom: 1px solid #b7bbbf;
            color: #fff;
            transition: all 0.5s;
            &.show_search {
              top: 112px;
            }
            > div {
              font-size: 15px;
              font-weight: bold;
            }
          }
          &.header_search {
            width: 100%;
            position: fixed;
            flex-direction: column;
            justify-items: center;
            background-color: #327594;
            margin: 0;
            padding: 10px 0;
            z-index: 9;
            top: 52px;
            border-bottom: 1px solid #b7bbbf;
            color: #fff;
            transition: all 0.5s;
            height: 10px;
            .search_input_box {
              display: none;
              width: 100%;
              cursor: auto;
              > div {
                margin: 0 20px;
              }
            }
            &.show_search {
              height: 50px;
              .search_input_box {
                display: flex;
                align-items: center;
                justify-content: center;
              }
              > i {
                transform: rotate(180deg);
              }
            }
            > i {
              transition: all 0.5s;
              font-size: 20px;
              font-weight: bold;
              cursor: pointer;
            }
          }
        }
      }
      .bottom_but {
        position: fixed;
        width: 96%;
        padding: 0 2%;
        display: flex;
        justify-content: space-between;
        bottom: 30px;
        a {
          color: #fff;
        }
      }
      .add_order_but {
        position: fixed;
        bottom: 80px;
        right: 2%;
        cursor: pointer;
        i {
          color: #67C23A;
          font-size: 48px;
        }
      }
      .signature_box {
        background: #fff;
        height: 25vh;
        width: 80vw;
        padding-top: 10%;
        text-align: center;
        @media (min-width: @screen-xs-max) {
          width: 30vw;
        }
        ul {
          padding-bottom: 20px;
          li {
            margin-top: 20px;
          }
        }
        .paymentmethodbut {
          display: flex;
          justify-items: center;
          justify-content: center;
          margin-top: 20px;
          .mint-button {
            /*margin-right: 20px;*/
            margin: 0 10px;
            cursor: pointer;
          }
        }
      }
    }
    .pdfimgmode {
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      z-index: 999999;
      top: 0;
      width: 100%;
      height: 100%;
      transition: all;
      background-color: rgba(0, 0, 0, 0.5);
      iframe {
        width: 70%;
        height: 90%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/orderlist_child/delivery.vue